/** A hint is one line of the keystroke stream (id + text, nothing stored). A suggestion is the
 * address a person picked, resolved once into the parts the record saves. Two shapes on purpose:
 * the provider bills them two orders of magnitude apart (docs/ADDRESS-PROVIDER-GEOSCAPE.md). */
export type AddressHint={id:string;label:string};
export type AddressSuggestion={
 id:string;
 label:string;
 value:{unit:string|null;street_number:string|null;street_name:string;suburb:string|null;postcode:string|null};
 state?:string|null;
 location?:{lat:number;lng:number}|null;
};

/** The street portion of a selected address. Suburb and postcode stay in their own opportunity
 * fields so Proposal address reads do not repeat them after joining the saved parts. */
export function selectedStreet(value:AddressSuggestion['value']):string{
 const street=[value.street_number,value.street_name].filter(Boolean).join(' ');
 if(!value.unit)return street;
 return /^\d+[a-z]?$/i.test(value.unit)?`${value.unit}/${street}`:`${value.unit}, ${street}`;
}
